<div>
    <ul class="flex space-x-2 rtl:space-x-reverse">
        <li>
            <a href="javascript:;" class="text-primary hover:underline">Forms</a>
        </li>
        <li class="before:content-['/'] ltr:before:mr-2 rtl:before:ml-2">
            <span>Input Mask</span>
        </li>
    </ul>
    <div class="space-y-8 pt-5">
        <div class="panel flex items-center overflow-x-auto whitespace-nowrap p-3 text-primary">
            <div class="rounded-full bg-primary p-1.5 text-white ring-2 ring-primary/30 ltr:mr-3 rtl:ml-3">
                <icon-bell />
            </div>
            <span class="ltr:mr-3 rtl:ml-3">Documentation: </span
            ><a href="https://www.npmjs.com/package/angular2-text-mask" target="_blank" class="block hover:underline"
                >https://www.npmjs.com/package/angular2-text-mask</a
            >
        </div>

        <div class="grid grid-cols-1 gap-6 xl:grid-cols-2">
            <!-- Basic -->
            <div class="panel">
                <div class="mb-5 flex items-center justify-between">
                    <h5 class="text-lg font-semibold dark:text-white-light">Static Mask Basic</h5>
                    <a class="font-semibold hover:text-gray-400 dark:text-gray-400 dark:hover:text-gray-600" href="javascript:;" (click)="toggleCode('code1')">
                        <span class="flex items-center">
                            <icon-code class="me-2" />
                            Code
                        </span>
                    </a>
                </div>
                <div class="mb-5">
                    <p class="mb-5 text-white-dark">Input mask are use with <span class="text-danger">input</span> tags.</p>
                    <form>
                        <fieldset class="grid grid-cols-1 items-end gap-4 md:grid-cols-2">
                            <div>
                                <label for="staticMask1" class="text-white-dark">textMask="'##-#######'" (99-9999999)</label>
                                <input id="staticMask1" type="text" placeholder="__-_______" class="form-input" [textMask]="{mask: mask1}" />
                            </div>
                            <div>
                                <label for="staticMask2" class="text-white-dark">textMask="'AA-####'" (aa-9999)</label>
                                <input id="staticMask2" type="text" placeholder="__-____" class="form-input" [textMask]="{mask: mask2}" />
                            </div>
                        </fieldset>
                    </form>
                </div>
                <ng-container *ngIf="codeArr.includes('code1')">
                    <pre> <code [languages]="['xml','typescript']" highlight="&lt;!-- static mask basic --&gt;
&lt;form&gt;
  &lt;fieldset class=&quot;grid grid-cols-1 items-end gap-4 md:grid-cols-2&quot;&gt;
        &lt;div&gt;
            &lt;label for=&quot;staticMask1&quot; class=&quot;text-white-dark&quot;&gt;textMask=&quot;'##-#######'&quot; (99-9999999)&lt;/label&gt;
            &lt;input id=&quot;staticMask1&quot; type=&quot;text&quot; placeholder=&quot;__-_______&quot; class=&quot;form-input&quot; [textMask]=&quot;{mask: mask1}&quot; /&gt;
        &lt;/div&gt;
        &lt;div&gt;
            &lt;label for=&quot;staticMask2&quot; class=&quot;text-white-dark&quot;&gt;textMask=&quot;'AA-####'&quot; (aa-9999)&lt;/label&gt;
            &lt;input id=&quot;staticMask2&quot; type=&quot;text&quot; placeholder=&quot;__-____&quot; class=&quot;form-input&quot; [textMask]=&quot;{mask: mask2}&quot; /&gt;
        &lt;/div&gt;
    &lt;/fieldset&gt;
&lt;/form&gt;

&lt;!-- script --&gt;
mask1 = [/\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
mask2 = [/[A-Za-z]/,/[A-Za-z]/, '-', /\d/, /\d/, /\d/, /\d/];"></code> </pre>
                </ng-container>
            </div>
            <div class="panel">
                <div class="mb-5 flex items-center justify-between">
                    <h5 class="text-lg font-semibold dark:text-white-light">Alternate masks</h5>
                    <a class="font-semibold hover:text-gray-400 dark:text-gray-400 dark:hover:text-gray-600" href="javascript:;" (click)="toggleCode('code2')">
                        <span class="flex items-center">
                            <icon-code class="me-2" />
                            Code
                        </span>
                    </a>
                </div>
                <div class="mb-5">
                    <form>
                        <fieldset class="grid grid-cols-1 gap-4 md:grid-cols-2">
                            <div>
                                <label for="altnMask1" class="text-white-dark">textMask="'##.#'" (99.9)</label>
                                <input id="altnMask1" type="text" placeholder="__._" class="form-input" [textMask]="{mask: mask3}" />
                            </div>
                            <div>
                                <label for="altnMask2" class="text-white-dark">textMask="'##.##'" (99.99)</label>
                                <input id="altnMask2" type="text" placeholder="__.__" class="form-input" [textMask]="{mask: mask4}" />
                            </div>
                        </fieldset>
                    </form>
                </div>
                <ng-container *ngIf="codeArr.includes('code2')">
                    <pre> <code [languages]="['xml','typescript']" highlight="&lt;!-- alternate masks --&gt;
&lt;form&gt;
    &lt;fieldset class=&quot;grid grid-cols-1 gap-4 md:grid-cols-2&quot;&gt;
        &lt;div&gt;
            &lt;label for=&quot;altnMask1&quot; class=&quot;text-white-dark&quot;&gt;textMask=&quot;'##.#'&quot; (99.9)&lt;/label&gt;
            &lt;input id=&quot;altnMask1&quot; type=&quot;text&quot; placeholder=&quot;__._&quot; class=&quot;form-input&quot; [textMask]=&quot;{mask: mask3}&quot; /&gt;
        &lt;/div&gt;
        &lt;div&gt;
            &lt;label for=&quot;altnMask2&quot; class=&quot;text-white-dark&quot;&gt;textMask=&quot;'##.##'&quot; (99.99)&lt;/label&gt;
            &lt;input id=&quot;altnMask2&quot; type=&quot;text&quot; placeholder=&quot;__.__&quot; class=&quot;form-input&quot; [textMask]=&quot;{mask: mask4}&quot; /&gt;
        &lt;/div&gt;
    &lt;/fieldset&gt;
&lt;/form&gt;

&lt;!-- script --&gt;
mask3 = [/\d/, /\d/, '.', /\d/];
mask4 = [/\d/, /\d/, '.', /\d/, /\d/];"></code> </pre>
                </ng-container>
            </div>
            <div class="panel">
                <div class="mb-5 flex items-center justify-between">
                    <h5 class="text-lg font-semibold dark:text-white-light">Dynamic Syntax</h5>
                    <a class="font-semibold hover:text-gray-400 dark:text-gray-400 dark:hover:text-gray-600" href="javascript:;" (click)="toggleCode('code3')">
                        <span class="flex items-center">
                            <icon-code class="me-2" />
                            Code
                        </span>
                    </a>
                </div>
                <div class="mb-5">
                    <form>
                        <fieldset class="grid grid-cols-1 items-end gap-4 md:grid-cols-3">
                            <div>
                                <label for="dynamicMask1" class="text-white-dark">textMask="'#-AAA###'" {{'(9-a{1,3}9{1,3})'}}</label>
                                <input id="dynamicMask1" type="text" placeholder="_-__" class="form-input" [textMask]="{mask: mask5}" />
                            </div>
                            <div>
                                <label for="dynamicMask2" class="text-white-dark">textMask="'AA-####'" {{'(aa-9{1,4})'}}</label>
                                <input id="dynamicMask2" type="text" placeholder="__-____" class="form-input" [textMask]="{mask: mask6}" />
                            </div>
                            <div>
                                <label for="dynamicMask3" class="text-white-dark">textMask="'AA-##'" {{'(aa-9{1,2})'}}</label>
                                <input id="dynamicMask3" type="text" placeholder="__-__" class="form-input" [textMask]="{mask: mask7}" />
                            </div>
                        </fieldset>
                    </form>
                </div>
                <ng-container *ngIf="codeArr.includes('code3')">
                    <pre> <code [languages]="['xml','typescript']" highlight="&lt;!-- dynamic syntax --&gt;
&lt;form&gt;
    &lt;fieldset class=&quot;grid grid-cols-1 items-end gap-4 md:grid-cols-3&quot;&gt;
        &lt;div&gt;
            &lt;label for=&quot;dynamicMask1&quot; class=&quot;text-white-dark&quot;&gt;textMask=&quot;'#-AAA###'&quot; {{'(9-a{1,3}9{1,3})'}}&lt;/label&gt;
            &lt;input id=&quot;dynamicMask1&quot; type=&quot;text&quot; placeholder=&quot;_-__&quot; class=&quot;form-input&quot; [textMask]=&quot;{mask: mask5}&quot; /&gt;
        &lt;/div&gt;
        &lt;div&gt;
            &lt;label for=&quot;dynamicMask2&quot; class=&quot;text-white-dark&quot;&gt;textMask=&quot;'AA-####'&quot; {{'(aa-9{1,4})'}}&lt;/label&gt;
            &lt;input id=&quot;dynamicMask2&quot; type=&quot;text&quot; placeholder=&quot;__-____&quot; class=&quot;form-input&quot; [textMask]=&quot;{mask: mask6}&quot; /&gt;
        &lt;/div&gt;
        &lt;div&gt;
            &lt;label for=&quot;dynamicMask3&quot; class=&quot;text-white-dark&quot;&gt;textMask=&quot;'AA-##'&quot; {{'(aa-9{1,2})'}}&lt;/label&gt;
            &lt;input id=&quot;dynamicMask3&quot; type=&quot;text&quot; placeholder=&quot;__-__&quot; class=&quot;form-input&quot; [textMask]=&quot;{mask: mask7}&quot; /&gt;
        &lt;/div&gt;
    &lt;/fieldset&gt;
&lt;/form&gt;

&lt;!-- script --&gt;
mask5 = [/\d/, '-',  /[A-Z,a-z]/, /[A-Z,a-z]/, /[A-Z,a-z]/, /\d/, /\d/, /\d/];
mask6 = [/[A-Z,a-z]/, /[A-Z,a-z]/, '-', /\d/, /\d/, /\d/, /\d/];
mask7 = [/[A-Z,a-z]/, /[A-Z,a-z]/, '-', /\d/, /\d/,];"></code> </pre>
                </ng-container>
            </div>
            <div class="panel">
                <div class="mb-5 flex items-center justify-between">
                    <h5 class="text-lg font-semibold dark:text-white-light">Date</h5>
                    <a class="font-semibold hover:text-gray-400 dark:text-gray-400 dark:hover:text-gray-600" href="javascript:;" (click)="toggleCode('code4')">
                        <span class="flex items-center">
                            <icon-code class="me-2" />
                            Code
                        </span>
                    </a>
                </div>
                <div class="mb-5">
                    <form>
                        <fieldset class="grid grid-cols-1 items-end gap-4 md:grid-cols-3">
                            <div>
                                <label for="dateMask1" class="text-white-dark">textMask="'##/##/####'" (dd/mm/yyyy)</label>
                                <input id="dateMask1" type="text" placeholder="__/__/____" class="form-input" [textMask]="{mask: mask8}" />
                            </div>
                            <div>
                                <label for="dateMask2" class="text-white-dark">textMask="'##-##-####'" (99-99-9999)</label>
                                <input id="dateMask2" type="text" placeholder="__-__-____" class="form-input" [textMask]="{mask: mask9}" />
                            </div>
                            <div>
                                <label for="dateMask3" class="text-white-dark">textMask="'## December, ####'" (99 December, 9999)</label>
                                <input id="dateMask3" type="text" placeholder="__ December, ____" class="form-input" [textMask]="{mask: mask10}" />
                            </div>
                        </fieldset>
                    </form>
                </div>
                <ng-container *ngIf="codeArr.includes('code4')">
                    <pre> <code [languages]="['xml','typescript']" highlight="&lt;!-- date --&gt;
&lt;form&gt;
    &lt;fieldset class=&quot;grid grid-cols-1 items-end gap-4 md:grid-cols-3&quot;&gt;
        &lt;div&gt;
            &lt;label for=&quot;dateMask1&quot; class=&quot;text-white-dark&quot;&gt;textMask=&quot;'##/##/####'&quot; (dd/mm/yyyy)&lt;/label&gt;
            &lt;input id=&quot;dateMask1&quot; type=&quot;text&quot; placeholder=&quot;__/__/____&quot; class=&quot;form-input&quot; [textMask]=&quot;{mask: mask8}&quot; /&gt;
        &lt;/div&gt;
        &lt;div&gt;
            &lt;label for=&quot;dateMask2&quot; class=&quot;text-white-dark&quot;&gt;textMask=&quot;'##-##-####'&quot; (99-99-9999)&lt;/label&gt;
            &lt;input id=&quot;dateMask2&quot; type=&quot;text&quot; placeholder=&quot;__-__-____&quot; class=&quot;form-input&quot; [textMask]=&quot;{mask: mask9}&quot; /&gt;
        &lt;/div&gt;
        &lt;div&gt;
            &lt;label for=&quot;dateMask3&quot; class=&quot;text-white-dark&quot;&gt;textMask=&quot;'## December, ####'&quot; (99 December, 9999)&lt;/label&gt;
            &lt;input id=&quot;dateMask3&quot; type=&quot;text&quot; placeholder=&quot;__ December, ____&quot; class=&quot;form-input&quot; [textMask]=&quot;{mask: mask10}&quot; /&gt;
        &lt;/div&gt;
    &lt;/fieldset&gt;
&lt;/form&gt;

&lt;!-- script --&gt;
mask8 = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
mask9 = [/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
mask10 = [/\d/, /\d/, ' ', 'D','e','c','e','m', 'b','e', 'r', ' ', /\d/, /\d/, /\d/, /\d/];"></code> </pre>
                </ng-container>
            </div>
            <div class="panel">
                <div class="mb-5 flex items-center justify-between">
                    <h5 class="text-lg font-semibold dark:text-white-light">IP</h5>
                    <a class="font-semibold hover:text-gray-400 dark:text-gray-400 dark:hover:text-gray-600" href="javascript:;" (click)="toggleCode('code5')">
                        <span class="flex items-center">
                            <icon-code class="me-2" />
                            Code
                        </span>
                    </a>
                </div>
                <div class="mb-5">
                    <form>
                        <fieldset>
                            <label for="ipMask" class="text-white-dark">textMask="'###.###.###.###'" (192.198.1.1)</label>
                            <input id="ipMask" type="text" placeholder="___.___.___.___" class="form-input" [textMask]="{mask: mask11}" />
                        </fieldset>
                    </form>
                </div>
                <ng-container *ngIf="codeArr.includes('code5')">
                    <pre> <code [languages]="['xml','typescript']" highlight="&lt;!-- ip --&gt;
&lt;form&gt;
    &lt;fieldset&gt;
        &lt;label for=&quot;ipMask&quot; class=&quot;text-white-dark&quot;&gt;textMask=&quot;'###.###.###.###'&quot; (192.198.1.1)&lt;/label&gt;
        &lt;input id=&quot;ipMask&quot; type=&quot;text&quot; placeholder=&quot;___.___.___.___&quot; class=&quot;form-input&quot; [textMask]=&quot;{mask: mask11}&quot; /&gt;
    &lt;/fieldset&gt;
&lt;/form&gt;

&lt;!-- script --&gt;
mask11 = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/];"></code> </pre>
                </ng-container>
            </div>
            <div class="panel">
                <div class="mb-5 flex items-center justify-between">
                    <h5 class="text-lg font-semibold dark:text-white-light">Phone</h5>
                    <a class="font-semibold hover:text-gray-400 dark:text-gray-400 dark:hover:text-gray-600" href="javascript:;" (click)="toggleCode('code6')">
                        <span class="flex items-center">
                            <icon-code class="me-2" />
                            Code
                        </span>
                    </a>
                </div>
                <div class="mb-5">
                    <form>
                        <fieldset>
                            <label for="phoneMask" class="text-white-dark">textMask="'(###) ###-####'" ((999) 999-9999)</label>
                            <input id="phoneMask" type="text" placeholder="(___) ___-____" class="form-input" [textMask]="{mask: mask12}" />
                        </fieldset>
                    </form>
                </div>
                <ng-container *ngIf="codeArr.includes('code6')">
                    <pre> <code [languages]="['xml','typescript']" highlight="&lt;!-- phone --&gt;
&lt;form&gt;
    &lt;fieldset&gt;
        &lt;label for=&quot;phoneMask&quot; class=&quot;text-white-dark&quot;&gt;textMask=&quot;'(###) ###-####'&quot; ((999) 999-9999)&lt;/label&gt;
        &lt;input id=&quot;phoneMask&quot; type=&quot;text&quot; placeholder=&quot;(___) ___-____&quot; class=&quot;form-input&quot; [textMask]=&quot;{mask: mask12}&quot; /&gt;
    &lt;/fieldset&gt;
&lt;/form&gt;

&lt;!-- script --&gt;
mask12 =  ['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];"></code> </pre>
                </ng-container>
            </div>
            <div class="panel">
                <div class="mb-5 flex items-center justify-between">
                    <h5 class="text-lg font-semibold dark:text-white-light">Currency</h5>
                    <a class="font-semibold hover:text-gray-400 dark:text-gray-400 dark:hover:text-gray-600" href="javascript:;" (click)="toggleCode('code7')">
                        <span class="flex items-center">
                            <icon-code class="me-2" />
                            Code
                        </span>
                    </a>
                </div>
                <div class="mb-5">
                    <form>
                        <fieldset>
                            <label for="currencyMask" class="text-white-dark">$999,9999,999.99</label>
                            <input id="currencyMask" type="text" placeholder="$___,____,___.__" class="form-input" [textMask]="{mask: mask13}" />
                        </fieldset>
                    </form>
                </div>
                <ng-container *ngIf="codeArr.includes('code7')">
                    <pre> <code [languages]="['xml','typescript']" highlight="&lt;!-- currency --&gt;
&lt;form&gt;
    &lt;fieldset&gt;
        &lt;label for=&quot;currencyMask&quot; class=&quot;text-white-dark&quot;&gt;$999,9999,999.99&lt;/label&gt;
        &lt;input id=&quot;currencyMask&quot; type=&quot;text&quot; placeholder=&quot;$___,____,___.__&quot; class=&quot;form-input&quot; [textMask]=&quot;{mask: mask13}&quot; /&gt;
    &lt;/fieldset&gt;
&lt;/form&gt;

&lt;!-- script --&gt;
mask13 = ['$', /\d/, /\d/, /\d/, ',', /\d/, /\d/, /\d/, /\d/, ',', /\d/, /\d/, /\d/, '.', /\d/, /\d/];"></code> </pre>
                </ng-container>
            </div>
        </div>
    </div>
</div>
